import { Divider, Space, Typography, Layout } from "antd";
import logo from "../../assets/logo.png";
import "./../../styles/CustomFooter.css";

const { Text } = Typography;
const { Footer } = Layout;

const DemoFooter = () => {
  const handleOkkavClick = () => {
    window.open("https://www.okkav.it", "_blank", "noopener,noreferrer");
  };

  return (
    <Footer
      style={{
        textAlign: "center",
        padding: "6px 50px",
        position: "sticky",
        bottom: 0,
      }}
      className="custom-footer"
    >
      <Space align="center" size="small">
        <Text type="secondary" style={{ fontSize: "12px" }}>
          <Text
            strong
            style={{
              color: "#262626",
              cursor: "pointer",
              transition: "color 0.2s ease",
            }}
            onClick={handleOkkavClick}
            onMouseEnter={(e) => {
              e.currentTarget.style.color = "#1890ff";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.color = "#262626";
            }}
          >
            OKKAV srl
          </Text>
        </Text>

        <Divider type="vertical" style={{ height: "20px" }} />

        <a
          href="https://www.okkav.it"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            display: "inline-block",
            transition: "opacity 0.2s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.opacity = "0.7";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.opacity = "1";
          }}
        >
          <img
            src={logo}
            alt="Okkav Logo"
            style={{
              height: "30px",
              width: "auto",
              cursor: "pointer",
            }}
          />
        </a>
      </Space>
    </Footer>
  );
};

export default DemoFooter;
